export const checkSubMenuPermissions = (permissions: string, rights: Array<string>): boolean => {
    let isValid = false
    if (permissions) {
        const userPermissions = JSON.parse(permissions)
        userPermissions.map((item) => {
            rights.map((page) => {
                if (page === item.page) {
                    if (item.rights.View || item.rights.Update || item.rights.Delete) {
                        isValid = true
                    }
                }
            })
        })
    }
    return isValid
}

export const checkMenuPermissions = (permissions: string, page: string) => {
    let isValid = false
    if (permissions) {
        const userPermissions = JSON.parse(permissions)
        userPermissions.map((item)=> {
            if (page === item.page) {
                if (item.rights.View || item.rights.Update || item.rights.Delete) {
                    isValid = true
                }
            }
        })
    }
}

export const checkPermission = (permissions: string, page: string, right: string): boolean => {
    let isValid = false
    if (permissions) {
        const userPermissions = JSON.parse(permissions)
        userPermissions.map((item) => {
            if (item.page === page) {
               isValid = item.rights[right]
            }
        })
    }
    return isValid
}